import React from "react";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/summary/summary.less";

class SummaryTotals extends React.Component {
    render() {
        let i = 0;
        return (
            <div className="summary-total" name="joinSummaryTotal">
                <div className="summary-section-title">
                    {translate("Totals")}
                </div>
                {this.props.totals.map(total => {
                    return (
                        <div key={i++} className="total-sum">
                            <div className="summary-total-text">{total.text}</div>
                            <div className="summary-total-amount">{total.amount}</div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default SummaryTotals;



// WEBPACK FOOTER //
// ./src/components/summary/SummaryTotals.js